import React, { memo } from 'react';
import { Select } from 'antd';
import { shallowEqual, useSelector } from 'react-redux';
import { dspxGetChildrens } from '../../../../../../helpers/dspx-utils';
import { ReactComponent as FlagsFilterIcon } from '../../../../../../resource/TopicFilterIcon.svg';
import {
  NotWarrantyIcon,
  PossWarrantyIcon,
  WarrantyIcon,
} from '../../../../../../resource/icons';
import {
  hasFilterValue,
  selectWarrantyActiveCount,
} from '../../../model/activity';
import { useRequestFilterCommands } from '../../../model/commandsContext';
import { requestFilterSectionIds } from '../../../model/sectionExpansion';
import { selectWarrantyOrganizations } from '../../../model/selectors';
import { useFilterChange } from '../../../model/useFilterChange';
import FilterField from '../../primitives/FilterField';
import FlagControl from '../../primitives/FlagControl';
import FilterSection from '../../primitives/FilterSection';
import { compactMultiSelectTagProps } from '../../primitives/selectTagProps';
import styles from './WarrantyFilterSection.module.scss';

const selectWarrantyFilterState = (state) => {
  const filter = state.filterStore;

  return {
    valueWarrantyOrg: filter.valueWarrantyOrg,
    warranty: filter.warranty,
    notWarranty: filter.notWarranty,
    possWarranty: filter.possWarranty,
  };
};

const WarrantyFilterSection = () => {
  const filterCommands = useRequestFilterCommands();
  const filter = useSelector(selectWarrantyFilterState, shallowEqual);
  const warrantyOrganizations = useSelector(selectWarrantyOrganizations);
  const activeCount = useSelector(selectWarrantyActiveCount);
  const { changeFilter } = useFilterChange();

  return (
    <FilterSection
      sectionId={requestFilterSectionIds.warranty}
      heading="Гарантия"
      description="Гарантийность, организация"
      icon={<FlagsFilterIcon />}
      activeCount={activeCount}
    >
      <div className={styles.grid}>
        <FlagControl
          active={filter.warranty}
          icon={<WarrantyIcon />}
          onChange={(value) => {
            changeFilter(filterCommands.applyWarranty(value, 1));
          }}
        >
          Гарантия
        </FlagControl>

        <FlagControl
          active={filter.notWarranty}
          icon={<NotWarrantyIcon />}
          onChange={(value) => {
            changeFilter(filterCommands.applyNotWarranty(value, 0));
          }}
        >
          Не гарантия
        </FlagControl>

        <FlagControl
          active={filter.possWarranty}
          icon={<PossWarrantyIcon />}
          onChange={(value) => {
            changeFilter(filterCommands.applyPossWarranty(value));
          }}
        >
          Возможно гарантия
        </FlagControl>

        <FilterField
          label="Подрядная организация"
          active={hasFilterValue(filter.valueWarrantyOrg)}
          className={styles.fullWidth}
        >
          <Select
            {...compactMultiSelectTagProps}
            mode="multiple"
            defaultActiveFirstOption={false}
            allowClear={true}
            placeholder="Выберите подрядную организацию"
            notFoundContent="нет данных"
            value={filter.valueWarrantyOrg}
            onChange={(value) => {
              changeFilter(filterCommands.applyWarrantyOrg(value));
            }}
            optionFilterProp="searchtext"
          >
            {dspxGetChildrens(warrantyOrganizations)}
          </Select>
        </FilterField>
      </div>
    </FilterSection>
  );
};

export default memo(WarrantyFilterSection);
